















































































































































































































































































































































































































import {
  CategoryCategoryDTO,
  CategoryCreateSubCategoryRequest,
  CategoryManagerService,
  CategorySubCategoryDTO,
  CategoryUpdateSubCategoryRequest,
} from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import Error from "@/views/pages/notFound.vue";
import _ from "lodash";
import cloneDeep from "lodash/cloneDeep";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "StoreCategoryListComponent",
  components: {
    Error,
    QMultiSelect,
    QErrors,
    QSearch,
    QPaginate,
    QTableHeader,
    Multiselect,
  },
})
export default class StoreCategoryListComponent extends Vue {
  public categories: CategoryCategoryDTO[] = [];
  public editingCategories: any[] = [];
  public subCategories: CategorySubCategoryDTO[] = [];

  public errors = {};
  public updateErrors = {};

  public newSubCategory: CategoryCreateSubCategoryRequest = {
    category_id: null,
    display_order: 1,
    name: null,
    name_en: null,
    name_cn: null,
  };

  public currentSubCategory: CategoryUpdateSubCategoryRequest = {
    id: null,
    category_id: null,
    display_order: 1,
    name: null,
    name_en: null,
    name_cn: null,
  };

  public creating = false;
  public edit_id = null;
  public editingCategory = false;

  public filter = {
    sort: "created_at",
    direction: "asc",
    categories: [] as string[],
  };

  public languages = {
    ja: true,
    en: true,
    cn: false,
  };

  public resetNewSubCategory() {
    this.newSubCategory = {
      category_id: null,
      display_order: 1,
      name: null,
      name_en: null,
      name_cn: null,
    };
  }

  public resetCurrentSubCategory() {
    this.currentSubCategory = {
      id: null,
      category_id: null,
      display_order: 1,
      name: null,
      name_en: null,
      name_cn: null,
    };
  }

  public mounted() {
    this.getCategory();
    this.search();
  }

  public async getSubCategory() {
    const result = await CategoryManagerService.adminSubCategory({
      categories: this.filter.categories,
      direction: this.filter.direction,
    });

    this.subCategories = result.data.sub_categories;
  }

  public normalizer(node) {
    return {
      id: node.id,
      label: node.name,
    };
  }

  public async createSubCategory() {
    this.errors = {};
    let result;
    try {
      const data = { ...this.newSubCategory };

      if (!this.languages.en) {
        delete data.name_en;
      }

      if (!this.languages.cn) {
        delete data.name_cn;
      }

      result = await CategoryManagerService.adminSubCategoryCreate(data);
      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
        await this.getSubCategory();
        this.resetNewSubCategory();
        this.creating = false;
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      } else {
        qNotify.error({
          text: result.body.message,
        });
      }
    }
  }

  public async updateSubCategory() {
    this.updateErrors = {};
    let result;

    const data = { ...this.currentSubCategory };

    if (!this.languages.en) {
      delete data.name_en;
    }

    if (!this.languages.cn) {
      delete data.name_cn;
    }

    try {
      result = await CategoryManagerService.adminSubCategoryUpdate(data);
      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
        await this.getSubCategory();
        this.resetCurrentSubCategory();
        this.edit_id = null;
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.updateErrors = result.body.errors;
      } else {
        qNotify.error({
          text: result.body.message,
        });
      }
    }
  }

  public confirmDeleteCreateSubCategory() {
    this.resetNewSubCategory();
    this.creating = false;
  }

  public confirmDeleteUpdateSubCategory() {
    this.$modal.showDelete({
      text: this.$t("common.message.delete_confirm"),
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.deleteSubCategory();
      },
    });
  }

  public async deleteSubCategory() {
    this.errors = {};
    let result;
    try {
      result = await CategoryManagerService.adminSubCategoryDelete({
        id: this.currentSubCategory.id,
      });
      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
        await this.getSubCategory();
        this.resetCurrentSubCategory();
        this.edit_id = null;
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      } else {
        qNotify.error({
          text: result.body.message,
        });
      }
      await this.getSubCategory();
    }
  }

  public openCreateSubCategoryForm() {
    this.creating = true;
    this.resetNewSubCategory();
    this.errors = {};
  }

  public openEditSubCategoryForm(value: CategorySubCategoryDTO) {
    this.edit_id = value.id;
    this.updateErrors = {};
    this.currentSubCategory = {
      id: value.id,
      category_id: value.category_id,
      display_order: value.display_order,
      name: value.name,
      name_en: value.name_en,
      name_cn: value.name_cn,
    };
  }

  public closeEditSubCategoryForm() {
    this.edit_id = null;
    this.updateErrors = {};
    this.currentSubCategory = {
      id: null,
      category_id: null,
      display_order: 1,
      name: null,
      name_en: null,
      name_cn: null,
    };
  }

  public search() {
    this.creating = false;
    this.getSubCategory();
  }

  public reset() {
    this.filter.categories = [];
    this.getSubCategory();
  }

  // Category
  public async getCategory() {
    const result = await CategoryManagerService.adminCategory({});

    this.categories = result.data.categories;
  }

  public editCategories() {
    this.getCategory().then(() => {
      this.editingCategories = JSON.parse(JSON.stringify(this.categories));
      this.editingCategory = true;
    });
    this.errors = {};
  }

  public cancelEditCategories() {
    this.editingCategory = false;
    this.errors = {};
  }

  public async syncCategories() {
    this.errors = {};
    let result;

    const data = cloneDeep(this.editingCategories);

    for (const value of data) {
      if (!this.languages.en) {
        delete value.name_en;
      }

      if (!this.languages.cn) {
        delete value.name_cn;
      }
    }

    try {
      result = await CategoryManagerService.adminCategorySync({
        categories: data,
      });
      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
        await this.getCategory();
        this.editingCategories = JSON.parse(JSON.stringify(this.categories));
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      } else {
        qNotify.error({
          text: result.body.message,
        });
      }
    }
  }

  public addCategory() {
    this.editingCategories = [
      {
        id: null,
        display_order: 1,
        name: null,
        name_en: null,
        name_cn: null,
        is_deletable: true,
      },
      ...this.editingCategories,
    ];
  }

  public confirmDeleteCategory(index) {
    const category = this.editingCategories[index];

    if (
      _.isEqual(category, {
        id: null,
        display_order: 1,
        name: null,
        name_en: null,
        name_cn: null,
      })
    ) {
      this.deleteCategory(index);
    } else {
      this.$modal.showDelete({
        text: this.$t("common.message.delete_confirm"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.deleteCategory(index);
        },
      });
    }
  }

  public confirmCancel() {
    if (_.isEqual(this.categories, this.editingCategories)) {
      this.cancelEditCategories();
    } else {
      this.$modal.showCancel({
        text: this.$t("common.message.cancel_confirm"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.cancelEditCategories();
        },
      });
    }
  }

  public deleteCategory(index) {
    console.log(this.editingCategories[index].id);
    if (this.editingCategories[index].id === null) {
      this.editingCategories.splice(index, 1);
    } else {
      this.editingCategories[index] = {
        ...this.editingCategories[index],
        status: "delete",
      };
    }
    this.errors = {};
  }

  public changeDirection() {
    this.filter.direction === "asc"
      ? (this.filter.direction = "desc")
      : (this.filter.direction = "asc");
    if (this.filter.direction === "asc") {
      this.subCategories.sort((a, b) => a.display_order - b.display_order);
    } else {
      this.subCategories.sort((a, b) => b.display_order - a.display_order);
    }
  }
}
